import {
  Component,
  OnInit,
  OnChanges,
  SimpleChanges,
  HostListener,
  ElementRef,
  ViewChild,
  Renderer2,
} from '@angular/core';
import * as $ from 'jquery';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Platform } from '@ionic/angular';
import { ServiceService } from 'src/app/mastermodule/service/service.service';
import { Storage } from '@ionic/storage';
import { Capacitor } from '@capacitor/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { filter } from 'rxjs/operators';
import { ROUTE_TITLES } from './route-titles.constant';

export interface NavPage {
  id: number | string;
  modname: string;
  pagename: string;
  pageseq: number;
  route: string;
  inline_of?: string;
}

export interface NavSubmenu {
  key: string;
  title: string;
  submenuseq: number;
  icon: string;
  pages: NavPage[];
}

export interface NavMenu {
  key: string;
  title: string;
  menuseq: number;
  icon: string;
  directPages: NavPage[];
  submenus: NavSubmenu[];
}

const ROUTE_PREFIX_MAP: Record<string, string> = {
  // Home / Dashboard
  'dashboard': '/master/dashboard',

  // Accounts
  'mod0136': '/master/accounts/mod0136/',
  'mod0138': '/master/accounts/mod0138/',
  'mod0139': '/master/accounts/mod0139',
  'mod0140': '/master/accounts/mod0140',
  'mod0141': '/master/accounts/mod0141/',
  'mod0153': '/master/accounts/mod0153/',
  'mod0183': '/master/accounts/mod0183/',
  'mod0271': '/master/accounts/mod0271',
  'mod0272': '/master/accounts/mod0272',
  'mod0473': '/master/accounts/mod0473/',

  // Admission
  'mod0201': '/master/admission/mod0201',

  // Billing
  'mod0169': '/master/billing/mod0169',
  'mod0170': '/master/billing/mod0170',
  'mod0281': '/master/billing/mod0281',
  'mod0381': '/master/billing/mod0381',

  // Exam
  'mod0129': '/master/exam/mod0129/',
  'mod0301': '/master/exam/mod0301',
  'mod0302': '/master/exam/mod0302',
  'mod0303': '/master/exam/mod0303',
  'mod0306': '/master/exam/mod0306',
  'mod0307': '/master/exam/mod0307',
  'mod0308': '/master/exam/mod0308',
  'mod0309': '/master/exam/mod0309',
  'mod0310': '/master/exam/mod0310',
  'mod0311': '/master/exam/mod0311',
  'mod0312': '/master/exam/mod0312/',

  // Reports
  'mod0143': '/master/reports/mod0143',
  'mod0145': '/master/reports/mod0145/',
  'mod0147': '/master/reports/mod0147/',
  'mod0148': '/master/reports/mod0148/',
  'mod0149': '/master/reports/mod0149/',
  'mod0150': '/master/reports/mod0150/',
  'mod0151': '/master/reports/mod0151/',
  'mod0152': '/master/reports/mod0152/',
  'mod0154': '/master/reports/mod0154/',
  'mod0156': '/master/reports/mod0156/',
  'mod0157': '/master/reports/mod0157/',
  'mod0159': '/master/reports/mod0159/',
  'mod0160': '/master/reports/mod0160/',
  'mod0161': '/master/reports/mod0161/',
  'mod0162': '/master/reports/mod0162/',
  'mod0163': '/master/reports/mod0163/',
  'mod0172': '/master/reports/mod0172',
  'mod0173': '/master/reports/mod0173',
  'mod0179': '/master/reports/mod0179',
  'mod0180': '/master/reports/mod0180',
  'mod0182': '/master/reports/mod0182/',
  'mod0270': '/master/reports/mod0270',
  'mod0413': '/master/reports/mod0413/',
  'mod0415': '/master/reports/mod0415',
  'mod0474': '/master/reports/mod0474/',
  'mod0475': '/master/reports/mod0475/',
};

const MENU_ICONS: Record<string, string> = {
  'home': 'fa fa-home',
  'learning': 'fa-solid fa-chalkboard',
  'career': 'fa fa-graduation-cap',
  'task': 'fas fa-tasks',
  'leads': 'fa fa-graduation-cap',
  'hrms': 'fa-solid fa-users',
  'inventory': 'fas fa-warehouse',
  'finance': 'fas fa-chart-pie',
};

const SUBMENU_ICONS: Record<string, string> = {
  'admission': 'fa fa-university',
  'exam': 'fa-solid fa-pen-to-square',
  'report': 'fa fa-file',
  'attendance': 'fa fa-clock',
  'certificate': 'fa fa-certificate',
  'master': 'fa fa-university',
  'whatsapp': 'fab fa-whatsapp',
  'transaction': 'fa fa-exchange',
  'user': 'fa fa-user',
  'punch': 'fa fa-hand-grab-o',
  'process': 'fa fa-gear',
};

@Component({
  selector: 'app-new-navbar',
  templateUrl: './new-navbar.component.html',
  styleUrls: ['./new-navbar.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class NewNavbarComponent implements OnInit {

  key_session = '';
  user_name = '';
  user_type = '';
  user_id = '';

  sideBarPinned: boolean = false;
  nav_loading = true;
  isOpen: boolean = false;
  isActive: any;
  selectedCompany: any = null;

  privilage_array: string[] = [];
  NAME_OF_USER = '';
  head_variable: any;
  modName: string = '';
  appPlatform: string = '';
  isSidebarOpen = false;

  // Dynamic Navigation Tree
  navMenuItems: NavMenu[] = [];
  pageTitleMap = new Map<string, string>();

  constructor(
    private storage: Storage,
    private api: ServiceService,
    public platform: Platform,
    private router: Router,
    private cookies: CookieService,
    private renderer: Renderer2,
    private elRef: ElementRef
  ) {
    this.key_session = this.api.get_session_id_login();

    if (!this.key_session) {
      this.api.logout();
    } else {
      this.user_name = this.api.get_user_details_in_cookies();
      this.user_id = this.api.localStorage.getItem('user_id');
      this.user_type = this.api.localStorage.getItem('user_type');
      this.NAME_OF_USER = this.user_name;
      if (!this.user_id || !this.user_type) {
        this.api.logout();
      }

      this.modName = this.api.SplitUrl(window.location.href).split('?')[0];
      console.log('navbar.modName', this.modName);
    }

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateHeaderTitle(event.urlAfterRedirects || event.url);
        setTimeout(() => {
          this.applySidebarState();
          this.applyActiveRouteColor();
        }, 50);
      });
  }

  updateHeaderTitle(url: string) {
    if (!url) return;

    const cleanUrl = url.split('?')[0].split('#')[0].toLowerCase();

    // 1. Check exact match from DB pagename map
    if (this.pageTitleMap.has(cleanUrl)) {
      this.head_variable = this.pageTitleMap.get(cleanUrl);
      return;
    }

    const normalizedUrl = cleanUrl.replace(/^\/+|\/+$/g, '');
    const routeParts = normalizedUrl.split('/');

    // 2. Check full sub-paths from DB pagename map
    for (let i = 0; i < routeParts.length; i++) {
      const routeKey = '/' + routeParts.slice(i).join('/');
      if (this.pageTitleMap.has(routeKey)) {
        this.head_variable = this.pageTitleMap.get(routeKey);
        return;
      }
    }

    // 3. Check segments from DB pagename map (e.g. 'mod0107')
    const segments = normalizedUrl.split('/').filter(s => s.trim().length > 0);
    for (let i = segments.length - 1; i >= 0; i--) {
      const seg = segments[i];
      if (this.pageTitleMap.has(seg)) {
        this.head_variable = this.pageTitleMap.get(seg);
        return;
      }
    }

    // 4. Fallback to static ROUTE_TITLES if available
    for (let i = 0; i < routeParts.length; i++) {
      const routeKey = '/' + routeParts.slice(i).join('/');
      if (ROUTE_TITLES[routeKey]) {
        this.head_variable = ROUTE_TITLES[routeKey];
        return;
      }
    }

    for (let i = segments.length - 1; i >= 0; i--) {
      const seg = segments[i];
      if (ROUTE_TITLES[seg]) {
        this.head_variable = ROUTE_TITLES[seg];
        return;
      }
    }

    if (cleanUrl === '/master' || cleanUrl === '/master/') {
      this.head_variable = 'Home';
    }
  }

  ngOnChanges(changes: SimpleChanges): void { }

  ngOnInit() {
    this.sideBarPinned = this.api.localStorage.getItem('sideBarPinned') === 'true';
    this.appPlatform = Capacitor.getPlatform();

    this.loadSelectedCompanyFromDB();

    this.api.companyUpdated$.subscribe((updatedCompany) => {
      if (updatedCompany) {
        this.selectedCompany = updatedCompany;
      }
    });

    if (this.user_id && this.user_type) {
      this.get_privilage_function({
        user_id: this.user_id,
        user_type: this.user_type,
      });
    }

    this.api.sharedData$.subscribe(data => {
      if (data) {
        this.head_variable = data;
      }
    });

    $('#user_icon').attr('value', '1');
    $('.HideUser').hide();

    this.previewMenubar();
    this.applySidebarState();
    setTimeout(() => {
      this.applyActiveRouteColor();
    }, 200);
  }

  previewMenubar() {
    if (this.api.localStorage.getItem('sideBarPinned') == 'false') {
      this.sideBarPinned = false;
      this.openCloseSubmenuWithTimeout();
      this.openCloseSubmenuWithTimeoutMainmenu();
    }
    if (this.api.localStorage.getItem('sideBarPinned') == 'true') {
      this.navbarOpenClose(true, true);
      this.sideBarPinned = true;
      $('.sidebar-wrapper').addClass('pinned-sidebar');
      $('ion-content body').addClass('sidebar-pinned');

      this.isOpen = true;
      this.isActive = '';

      this.openCloseSubmenuWithTimeout();
      this.openCloseSubmenuWithTimeoutMainmenu();
    }
  }

  openCloseSubmenuWithTimeoutMainmenu() {
    setTimeout(() => {
      this.submenuOpenClose(
        this.api.localStorage.getItem('submenuOpenClose_selected_mainmenu'),
        this.api.localStorage.getItem('submenuOpenClose_selected_menu_mainmenu')
      );

      this.isActive = '';
      this.isOpen = true;
    }, 20);
  }

  loadSelectedCompanyFromDB(): Promise<void> {
    return new Promise((resolve) => {
      const requestData = {
        pno: 1,
        pageSize: 9999,
        searchText: '',
        sortCol: 'company_name',
        sortDir: 'asc',
      };

      this.api.call_http_post({
        url: environment.API_URL + 'mastermodule/GetCompanyMaster',
        data: requestData,
        successCb: (res) => {
          const allCompanies = res.data?.CompanyData || [];
          const selected = allCompanies.find(
            (x: any) => x.selectedflag === '1'
          );

          if (selected) {
            this.selectedCompany = selected;
            this.saveToStorage(selected);
          } else {
            this.selectedCompany = this.loadFromStorage();
          }

          resolve();
        },
        errorCb: (err) => {
          console.error('API Error:', err);
          resolve();
        },
      });
    });
  }

  saveToStorage(company: any) {
    try {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem('selectedCompany', JSON.stringify(company));
      }
    } catch (error) {
      console.warn('Could not save to storage:', error);
    }
  }

  loadFromStorage() {
    try {
      if (typeof sessionStorage !== 'undefined') {
        const saved = sessionStorage.getItem('selectedCompany');
        return saved ? JSON.parse(saved) : null;
      }
    } catch (error) {
      console.warn('Could not load from storage:', error);
    }
    return null;
  }

  openCloseSubmenuWithTimeout() {
    setTimeout(() => {
      this.submenuOpenClose(
        this.api.localStorage.getItem('submenuOpenClose_selected'),
        this.api.localStorage.getItem('submenuOpenClose_selected_menu')
      );

      this.isActive = '';
      this.isOpen = true;
  }, 50);
}

  /**
   * Constructs the 3-tier menu tree from database rows.
   * - Menus sorted by menuseq ASC
   * - Submenus sorted by submenuseq ASC
   * - Pages sorted by pageseq ASC
   * - inline_of items are EXCLUDED from navbar rendering, but registered for privilege checks and title resolution
   */
  buildNavigationTree(rawPages: any[]) {
    this.pageTitleMap.clear();

    // Default system routes
    this.pageTitleMap.set('dashboard', 'Dashboard');
    this.pageTitleMap.set('/master/dashboard', 'Dashboard');
    this.pageTitleMap.set('/master', 'Home');

    const menuMap = new Map<string, NavMenu>();

    for (const item of rawPages) {
      const modname = (item.modname || '').trim();
      const pagename = (item.pagename || '').trim();
      const route = ROUTE_PREFIX_MAP[modname] || `/master/${modname}`;

      // Index in pageTitleMap for dynamic head_variable (from privilage.pagename)
      if (modname && pagename) {
        this.pageTitleMap.set(modname.toLowerCase(), pagename);
        this.pageTitleMap.set(route.toLowerCase(), pagename);
      }

      // CRITICAL REQUIREMENT: inline_of items must NOT be rendered in the navbar
      const inlineOf = (item.inline_of || '').trim();
      if (inlineOf) {
        continue;
      }

      const menuTitle = (item.menu || '').trim();
      if (!menuTitle) continue;

      const menuKey = menuTitle.toLowerCase().replace(/[^a-z0-9]/g, '');
      const menuseq = Number(item.menuseq ?? 999);

      if (!menuMap.has(menuKey)) {
        menuMap.set(menuKey, {
          key: menuKey,
          title: menuTitle,
          menuseq: menuseq,
          icon: MENU_ICONS[menuKey] || 'fa fa-folder',
          directPages: [],
          submenus: [],
        });
      }

      const menu = menuMap.get(menuKey)!;
      const pageseq = Number(item.pageseq ?? 999);

      const pageObj: NavPage = {
        id: item.id,
        modname: modname,
        pagename: pagename,
        pageseq: pageseq,
        route: route,
        inline_of: item.inline_of,
      };

      const submenuTitle = (item.submenu || '').trim();

      if (!submenuTitle) {
        // Direct page under Main Menu
        menu.directPages.push(pageObj);
      } else {
        // Page belongs to a Submenu accordion group
        const submenuKey = submenuTitle.toLowerCase().replace(/[^a-z0-9]/g, '');
        const submenuseq = Number(item.submenuseq ?? 999);

        let subGroup = menu.submenus.find(s => s.key === submenuKey);
        if (!subGroup) {
          subGroup = {
            key: submenuKey,
            title: submenuTitle,
            submenuseq: submenuseq,
            icon: SUBMENU_ICONS[submenuKey] || 'fa fa-folder-open',
            pages: [],
          };
          menu.submenus.push(subGroup);
        }
        subGroup.pages.push(pageObj);
      }
    }

    // Sort menus by menuseq ASC
    this.navMenuItems = Array.from(menuMap.values()).sort((a, b) => a.menuseq - b.menuseq);

    // Sort submenus and pages by submenuseq and pageseq ASC
    for (const menu of this.navMenuItems) {
      menu.directPages.sort((a, b) => a.pageseq - b.pageseq);
      menu.submenus.sort((a, b) => a.submenuseq - b.submenuseq);
      for (const sub of menu.submenus) {
        sub.pages.sort((a, b) => a.pageseq - b.pageseq);
      }
    }
  }

  // Get allowed privileges from backend ORM API
  get_privilage_function(data: any) {
    this.api.call_http_post({
      url: environment.API_URL + 'mastermodule/get_privilage_function',
      data,
      modname: this.modName,
      successCb: (res: any) => {
        const result = res.data || {};
        const rawRows = result['dt'] || [];

        // Keep all privilege IDs (including inline_of) in privilage_array
        if (result['privilage_array'] && Array.isArray(result['privilage_array'])) {
          this.privilage_array = result['privilage_array'];
        } else if (Array.isArray(rawRows)) {
          this.privilage_array = rawRows.map((x: any) => String(x.id || x.page_id || x));
        }

        // Build navigation menu tree
        this.buildNavigationTree(rawRows);

        // Update header title based on current route
        this.updateHeaderTitle(this.router.url);

        this.previewMenubar();
        this.nav_loading = false;

        setTimeout(() => {
          this.applyActiveRouteColor();
        }, 200);
      },
      afterError: (error) => {
        console.error('get_privilage_function error:', error);
        this.nav_loading = false;
      },
    });
  }

  navbarOpenClose(open: boolean, clickTrigger: boolean = false) {
    this.isSidebarOpen = open;

    if (clickTrigger && !open) {
      this.api.localStorage.setItem('sideBarPinned', 'false');
      this.sideBarPinned = false;
    }
  }

  submenuOpenClose(selected: any, selected_menu: any) {
    if (selected_menu == 'mainmenu') {
      this.api.localStorage.setItem(
        'submenuOpenClose_selected_mainmenu',
        selected
      );
      this.api.localStorage.setItem(
        'submenuOpenClose_selected_menu_mainmenu',
        selected_menu
      );
    } else {
      this.api.localStorage.setItem('submenuOpenClose_selected', selected);
      this.api.localStorage.setItem(
        'submenuOpenClose_selected_menu',
        selected_menu
      );
    }

    var submenu = '.submenu-' + selected;
    var dropdown = '.dropdown-' + selected;

    if ($(dropdown).hasClass('active')) {
      $(submenu).slideUp(200);
      $(dropdown).removeClass('active');
    } else {
      if (this.isOpen == true) {
        if (this.isActive == selected) {
          $(dropdown).find(submenu).slideUp(200);
          this.isOpen = false;
          this.isActive = '';
        } else {
          this.isActive = '';

          if (selected_menu == 'mainmenu') {
            $(dropdown).find(submenu).slideDown(200);
            $(dropdown).parent().addClass('active');

            $('.sidebar-submenu:not(' + submenu + ')').slideUp(200);
            $('.sidebar-submenu-new:not(' + submenu + ')').slideUp(200);
            $('.sidebar-dropdown:not(' + dropdown + ')').removeClass('active');
            this.isActive = selected;
            this.isOpen = true;
          } else {
            $(dropdown).find(submenu).slideDown(200);
            $(dropdown).parent().addClass('active');

            $('.sidebar-submenu-new:not(' + submenu + ')').slideUp(200);
            $('.sidebar-dropdown:not(' + dropdown + ')').removeClass('active');

            this.isActive = selected;
            this.isOpen = true;
          }
        }
      } else {
        if (selected_menu == 'mainmenu') {
          $(dropdown).find(submenu).slideDown(200);
          $(dropdown).parent().addClass('active');

          $('.sidebar-submenu:not(' + submenu + ')').slideUp(200);
          $('.sidebar-submenu-new:not(' + submenu + ')').slideUp(200);
          $('.sidebar-dropdown:not(' + dropdown + ')').removeClass('active');
          this.isActive = selected;
          this.isOpen = true;
        } else {
          $(dropdown).find(submenu).slideDown(200);
          $(dropdown).parent().addClass('active');

          $('.sidebar-submenu-new:not(' + submenu + ')').slideUp(200);
          $('.sidebar-dropdown:not(' + dropdown + ')').removeClass('active');

          this.isActive = selected;
          this.isOpen = true;
        }
      }
    }
  }

  navigate(route: any) {
    const isPinned = this.api.localStorage.getItem('sideBarPinned') === 'true';
    if (!isPinned) {
      this.forceCloseSidebar();
    }
    this.router.navigate([route], { replaceUrl: true });
  }

  togglePinSidebar(selectedtype: any) {
    let sideBarPinned = $('.sidebar-wrapper').hasClass('pinned-sidebar');

    let isMobile = window.innerWidth < 768;
    if (sideBarPinned || isMobile) {
      $('.sidebar-wrapper').removeClass('pinned-sidebar');
      $('ion-content body').removeClass('sidebar-pinned');
      $('.navbar_header').removeClass('sidebar-pinned');
      this.api.localStorage.setItem('sideBarPinned', 'false');
    } else {
      $('.sidebar-wrapper').addClass('pinned-sidebar');
      $('ion-content body').addClass('sidebar-pinned');
      $('.navbar_header').addClass('sidebar-pinned');
      this.api.localStorage.setItem('sideBarPinned', 'true');
    }

    this.sideBarPinned = !sideBarPinned;

    if (sideBarPinned) {
      $('.navbar_header').css('color', '#6C0BA9');
      $('.navbar_header').css('margin-left', '-13em');
    } else {
      $('.navbar_header').css('color', '#6C0BA9');
      $('.navbar_header').css('margin-left', '13em');
    }
  }

  ShowUserProfile() {
    if ($('#user_icon').attr('value') == '0') {
      $('.HideUser').hide();
      $('#user_icon').attr('value', '1');
    } else {
      $('.HideUser').show();
      $('#user_icon').attr('value', '0');
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    const clickedInsideContent = $(event.target).closest('ion-content').length > 0;
    const clickedInsideSidebar = $(event.target).closest('.sidebar-wrapper').length > 0;
    const clickedNavbar = $(event.target).closest('.navbar_header').length > 0;

    if(clickedInsideContent && !clickedInsideSidebar && !clickedNavbar) {
    if (!this.sideBarPinned) {
      this.navbarOpenClose(false);
    }
  }

  if (!this.elRef.nativeElement.contains(event.target)) {
    $('.HideUser').hide();
    $('#user_icon').attr('value', '1');
  }
}

  clickRouteNode(routeclass: string) {
    this.api.localStorage.setItem('Navbar_Route_Node', routeclass);
  }

    clickRouteNodeSubmenu(routeclass_submenu: string) {
      this.api.localStorage.setItem(
        'Navbar_Route_Node_Submenu',
        routeclass_submenu
      );
    }

      clickRouteNodeMainmenu(routeclass_mainmenu: string) {
        this.api.localStorage.setItem(
          'Navbar_Route_Node_Mainmenu',
          routeclass_mainmenu
        );
      }

      mainmenuWithNoSubmenu() {
        this.api.localStorage.setItem('submenuOpenClose_selected_mainmenu', '');
        this.api.localStorage.setItem(
          'submenuOpenClose_selected_menu_mainmenu',
          ''
        );
        this.api.localStorage.setItem('Navbar_Route_Node_Submenu', '');
        this.api.localStorage.setItem('Navbar_Route_Node', '');
      }

      routeNodeinSubmenu() {
        this.api.localStorage.setItem('submenuOpenClose_selected', '');
        this.api.localStorage.setItem('submenuOpenClose_selected_menu', '');
        this.api.localStorage.setItem('Navbar_Route_Node', '');
      }

        checkPrivilageArrayOr(arr: string[]) {
          if (arr[0] == '0') {
            return true;
          } else {
            return arr.some((x) => this.privilage_array.includes(x));
          }
        }

          routerNextPage(url: string) {
            this.router.navigate([url]);
          }

          applySidebarState() {
            const isPinned = this.api.localStorage.getItem('sideBarPinned') === 'true';
            this.sideBarPinned = isPinned;

            if (isPinned) {
              this.isSidebarOpen = true;
              $('.sidebar-wrapper').addClass('pinned-sidebar');
              $('ion-content body').addClass('sidebar-pinned');
              $('.navbar_header').addClass('sidebar-pinned');
              $('.navbar_header').css('margin-left', '13em');
            } else {
              this.isSidebarOpen = false;
              $('.sidebar-wrapper').removeClass('pinned-sidebar');
              $('ion-content body').removeClass('sidebar-pinned');
              $('.navbar_header').removeClass('sidebar-pinned');
              $('.navbar_header').css('margin-left', '-13em');
            }
          }

          applyActiveRouteColor() {
            $('.routeColor').removeClass('routeColor');

            const main = this.api.localStorage.getItem('Navbar_Route_Node_Mainmenu');
            const sub = this.api.localStorage.getItem('Navbar_Route_Node_Submenu');
            const child = this.api.localStorage.getItem('Navbar_Route_Node');

            if (main) {
              $('.' + CSS.escape(main)).addClass('routeColor');
            }

            if (sub) {
              $('.' + CSS.escape(sub)).addClass('routeColor');
            }

            if (child) {
              $('.' + CSS.escape(child)).addClass('routeColor');
            }
          }

          forceCloseSidebar() {
            this.sideBarPinned = false;
            this.api.localStorage.setItem('sideBarPinned', 'false');

            this.isSidebarOpen = false;
            this.isOpen = false;
            this.isActive = '';

            $('.sidebar-submenu').slideUp(0);
            $('.sidebar-submenu-new').slideUp(0);
            $('.sidebar-dropdown').removeClass('active');
          }
        }
